import React from "react";
import { Link } from "react-router-dom";

export default function InternalLink({ ...props }) {
  const {link} = props;    
  const LinkParams= link + window?.location?.search 
  return (
                <Link
                  {...props}
                  to={LinkParams}
                >
                 {props?.children}
                </Link>
  );
}
